import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';
import { FinDeNavCbemDto } from "../../Models/CBEM";
import { ClientConfig, ClientNav, ClientNavResponse, PaginatedClientNavResponse } from "../../Models/Client-Nav";

export interface PreferenceResponse<T> {
  userId: string;
  preferenceKey: string;
  data: T | null;
  updatedAt?: string;
}

export interface PreferencePayload<T> {
  data: T;
  updatedAt?: string;
}

@Injectable({
  providedIn: "root",
})
export class ClientNavigatorService {
  // Service logic goes here
  private apiUrl = environment.apiUrl;

  constructor(private http:HttpClient) {

  }

    getClient_list(
      pageSize: number,
      lastEvaluatedKey?: Record<string, string> | null,
      sortBy?: string | null,
      search?: string | null,
      filters?: { insuranceTypes?: string[]; productGroups?: string[]; statuses?: string[] } | null
    ): Observable<PaginatedClientNavResponse> {
        const body: Record<string, any> = {
          PageSize: pageSize,
        };
        if (lastEvaluatedKey) {
          body['LastEvaluatedKey'] = JSON.stringify(lastEvaluatedKey);
        }
        if (sortBy) {
          body['SortBy'] = sortBy;
        }
        if (search) {
          body['Search'] = search;
        }
        if (filters?.insuranceTypes?.length) {
          body['InsuranceTypes'] = filters.insuranceTypes;
        }
        if (filters?.productGroups?.length) {
          body['ProductGroups'] = filters.productGroups;
        }
        if (filters?.statuses?.length) {
          body['Statuses'] = filters.statuses;
        }
        return this.http.post<PaginatedClientNavResponse>(`${this.apiUrl}/get-client-list`, body);
    }

    // to fetch filter parameters
    get_config_list(): Observable<ClientConfig[]> {
        return this.http.get<ClientConfig[]>(`${this.apiUrl}/get-config-list`);
    }
    
    getAllProducts(): Observable<{[key: string]: string}> {
    return this.http.get<{[key: string]: string}>(`${this.apiUrl}/get-all-products`);
    }
    getPresignedUrl(): Observable<{downloadURL: string}> {
        return this.http.get<{downloadURL: string}>(`${this.apiUrl}/export-clients-data`);
    }
    createClient(payload: { clientName: string; product: string; userId: string }): Observable<ClientNav> {
      return this.http.post<ClientNav>(`${this.apiUrl}/create-client`, payload);
    }

    getClientNavigatorPreferences<T>(userId: string): Observable<PreferenceResponse<T>> {
      return this.http.get<PreferenceResponse<T>>(`${this.apiUrl}/preferences/clientNavigator?userId=${encodeURIComponent(userId)}`);
    }

    saveClientNavigatorPreferences<T>(userId: string, payload: PreferencePayload<T>): Observable<{ success: boolean }> {
      return this.http.put<{ success: boolean }>(`${this.apiUrl}/preferences/clientNavigator?userId=${encodeURIComponent(userId)}`, payload);
    }
}